import { useTheme, useMediaQuery } from "@mui/material";

/**
 * Returns whether the current viewport is in mobile layout (below MUI sm breakpoint).
 * @returns {{ isMobile: boolean }}
 */
function useMobileScreen() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return { isMobile };
}

export default useMobileScreen;
